exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapse-item__tip[data-v-1aa4c13b]{font-style:italic;opacity:.8;display:inline-block;float:right;margin-right:1rem;font-weight:600;color:#f67e22}.collapse-item__tip[data-v-1aa4c13b]:hover{opacity:1}.alignR[data-v-1aa4c13b]{text-align:right}.drawer .el-collapse-item__header[data-v-1aa4c13b],.drawer .el-collapse-item__wrap[data-v-1aa4c13b]{background-color:#fafafa}.new-request__search-cont[data-v-1aa4c13b]{padding:0 0 30px}.new-request__search[data-v-1aa4c13b]{width:100%}.buttons-section[data-v-1aa4c13b]{margin-bottom:20px;text-align:center}.make-payment_date[data-v-1aa4c13b]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1aa4c13b","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/staff/blocks/MakeTips.vue
// module id = 484
// module chunks = 0